// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SectionOrderPendingValidation_wrapper__1Cf44"};